/** Display name for the contacts table Name column (never email). */
export function formatContactName(contact) {
    const name = [contact?.first_name, contact?.last_name]
        .map((part) => String(part || "").trim())
        .filter(Boolean)
        .join(" ");
    return name || "no name";
}

/** Prefer mobile, else location phone, for the overview Phone column. */
export function formatContactPhone(contact) {
    const mobile = String(contact?.telephone_mobile || "").trim();
    if (mobile) return mobile;
    return String(contact?.telephone_location || "").trim();
}
